import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getConfig } from "utils/helper";


const firebaseConfig = await getConfig()

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };